import actions from './constants';

export const showMetrics = (response) => ({
  type: actions.SHOW_METRICS,
  response,
});

export const showMetricsError = (error) => ({
  type: actions.SHOW_METRICS_ERROR,
  error,
});

export const fetchMetrics = (entities) => ({
  type: actions.FETCH_METRICS,
  entities,
});
